// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Fonts/Mulish-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue: #016fe9;
  --lightblue: #328aed;
  --ultralightblue: #e6f1fd;
  --white: #ffffff;
  --gray: #353535;
  --purple: #3f51b5;
  --lightgray: #929294;
  --lightpurple: #e8eaf5;
  --transpurple: #e4e4f9;
  --boxshadow: #9e9e9e;
  --transgray: #e5e5e5;
  --green: #158803;
  --transblue: rgba(1, 111, 233, 0.1);
  --whitegrey: rgba(255, 255, 255, 0.6);
  --border: #ced4da;
  --black: #000000;
  --red: #f23e36;
}

@font-face {
  font-family: "Mulish", sans-serif;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
}

@font-face {
  font-family: "Poppins", sans-serif;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

body {
  margin: 0;
  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif; */
  font-family: "Poppins", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px !important;
}

code {
  /* font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace; */
  font-family: "Poppins", sans-serif !important;
}

.css-1in441m {
  display: none !important;
}

.font-12 {
  font-size: 12px !important;
}

.font-14 {
  font-size: 14px !important;
}

.font-16 {
  font-size: 16px !important;
}

.font-11 {
  font-size: 11px !important;
}

.font-11-req-msg {
  font-size: 11px !important;
  display: flex;
  justify-content: flex-end;
}

.removelabel label {
  display: none;
}

.colorPurple {
  color: var(--purple);
}

.bgPurple {
  background: var(--purple);
  color: #fff;
}

.cursor {
  cursor: pointer;
}

.bgwhite {
  background: #fff;
}

.colorGreen {
  color: var(--green);
}

/*******************Pagination**********************/
.paginationdiv nav {
  height: auto;
  width: auto;
  border: 0;
}

.MuiTablePagination-actions {
  display: none;
}

.paginateno p {
  margin-bottom: 0 !important;
}

.chatdate {
  background: var(--lightpurple);
  margin: auto;
  padding: 5px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}

/****************************************/
/*******************Popup*****************/
.model {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001 !important;
}

.modeldiv {
  background-color: var(--white);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0 0 6px var(--boxshadow);
  padding: 60px;
  min-width: 550px;
  max-height: calc(100vh - 100px);
  overflow: auto;
  max-width: calc(100vw - 100px);
}

@media screen and (max-width: 650px) {
  .modeldiv {
    min-width: unset;
    width: calc(100vw - 32px);
    padding: 24px 16px;
  }
}

.modelprintdiv {
  background-color: var(--white);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0 0 6px var(--boxshadow);
  padding: 60px;
  /* min-width: 95%; */
  min-height: 90%;
  max-height: calc(100vh - 100px);
  overflow: auto;
  width: 100%;
  max-width: 650px;
}

.css-10nakn3-MuiModal-root-MuiPopover-root-MuiMenu-root {
  z-index: 10002 !important;
}

.modeldivChat {
  min-width: 0px !important;
  padding: 30px !important;
  max-width: 80vw !important;
  max-height: calc(100vh - 100px) !important;
  overflow: auto;
}

.modeldivDelete {
  background-color: var(--white);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0 0 6px var(--boxshadow);
  padding: 60px;
  min-width: 550px;
  max-height: calc(100vh - 100px);
  overflow: auto;
  max-width: calc(100vw - 100px);
  z-index: 1;
}

.modelWaitingRecording {
  background-color: var(--white);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0 0 6px var(--boxshadow);
  padding: 60px;
  min-width: 500px;
  max-height: calc(100vh - 100px);
  overflow: auto;
  max-width: 500px;
  z-index: 1;
}

.modelInstructions {
  background-color: var(--white);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0 0 6px var(--boxshadow);
  padding: 30px;
  min-width: 500px;
  max-height: calc(100vh - 100px);
  max-width: calc(100vw - 100px);
  /* overflow: auto; */
  z-index: 1;
}

.modelInstructionsContent {
  max-height: calc(100vh - 260px);
  overflow-y: auto;
}

.modelChat {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001 !important;
}

/************************bookstock popup******************************/
.bookstockmodeldiv {
  background-color: var(--white);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0 0 6px var(--boxshadow);
  padding: 60px;
  min-width: 360px;
  max-height: calc(100vh - 100px);
  overflow: auto;
  max-width: calc(100vw - 100px);
}

/**********************Loader************************/
.loaderBackdrop.MuiBackdrop-root {
  z-index: 10002;
}

.loader {
  color: #ffffff;
  font-size: 45px;
  text-indent: -9999em;
  overflow: hidden;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  transform: translateZ(0);
  animation: mltShdSpin 1.7s infinite ease, round 1.7s infinite ease;
}

@keyframes mltShdSpin {
  0% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,
      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }

  5%,
  95% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,
      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }

  10%,
  59% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em,
      -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em,
      -0.297em -0.775em 0 -0.477em;
  }

  20% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em,
      -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em,
      -0.749em -0.34em 0 -0.477em;
  }

  38% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em,
      -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em,
      -0.82em -0.09em 0 -0.477em;
  }

  100% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,
      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
}

@keyframes round {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.MuiInputBase-root legend.css-yjsfm1 {
  display: none !important;
}

.wrs_tickContainer {
  display: none !important;
}

.boxshadow {
  box-shadow: 1px 1px 5px 1px var(--transgray);
}

.tablecontent {
  width: calc(100vw - 540px);
}

.pdfView {
  width: 100vw;
}

.pdf-container div div {
  display: none;
}

.pdf-container div {
  background: var(--boxshadow1) !important;
}

.pdf-container canvas {
  margin: auto;
  max-width: 1000px !important;
  width: 100% !important;
  height: auto !important;
}

.controls {
  text-align: center;
  margin: 10px;
}

.MuiMenu-root {
  z-index: 10002 !important;
}

/******************SCroll bar*****************************/
::-webkit-scrollbar {
  width: 0.8em;
  height: 0.3em;
  display: none;
}

.scrollBarContent ::-webkit-scrollbar {
  display: inline-block;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-thumb {
  background-color: var(--lightgray);
  outline: 1px solid slategrey;
  border-radius: 5px;
  cursor: pointer;
}

.scrollbar::-webkit-scrollbar {
  display: inline-block;
}

@media print {
  pdf-viewer {
    display: none;
  }

  .pdfDiv {
    display: none !important;
  }

  .pdf-container {
    display: none;
  }
}

.chat {
  width: calc(100vw - 300px);
  height: 78vh;
  display: flex;
  align-items: center;
  margin: auto;
}

.teacherChat .chat {
  width: 100%;
  height: 100%;
}

.chat_hide {
  width: 100%;
  height: 100vh;
  display: none;
  align-items: center;
}

.chat__sidebar {
  height: 100%;
  background-color: #f9f5eb;
  flex: 0.2 1;
  padding: 20px;
  border-right: 1px solid #fdfdfd;
}

.chat__main {
  height: 100%;
  /* flex: 0.8; */
  width: 100%;
}

.message__container {
  width: 100%;
  height: calc(100vh - 236px);
  background-color: #fff;
  padding: 20px;
  overflow-y: auto;
  /* display: table-caption; */
}

.message__container>* {
  margin-bottom: 15px;
}

.message__chats {
  font-size: 14px;
  width: 98%;
}

.message__recipient {
  font-size: 14px;
  word-wrap: break-word;
  background-color: #c2f3c2;
  border-radius: 10px;
  -webkit-border-radius: 10px 15px 0 10px;
  -moz-border-radius: 10px 15px 0 10px;
  -ms-border-radius: 10px 15px 0 10px;
  -o-border-radius: 10px 15px 0 10px;
  margin: auto 0 5px auto;
  max-width: 82%;
  padding: 5px 15px;
  text-align: left;
  width: max-content;
}

.sender__name {
  text-align: right;
}

.message__status {
  position: fixed;
  bottom: 50px;
  font-size: 13px;
  font-style: italic;
}

.css-1d3z3hw-MuiOutlinedInput-notchedOutline {
  top: 0 !important;
}

.message__sender {
  text-align: left;
  background-color: rgb(194, 243, 194);
  padding: 5px 15px;
  border-radius: 10px;
  width: max-content;
  max-width: 82%;
  margin: auto;
  margin-right: 0;
  margin-bottom: 10px;
  word-wrap: break-word;
  -webkit-border-radius: 10px 15px 0px 10px;
  -moz-border-radius: 10px 15px 0px 10px;
  -ms-border-radius: 10px 15px 0px 10px;
  -o-border-radius: 10px 15px 0px 10px;
}

.chatOwnerName {
  font-size: 12px;
}

.alertBox {
  display: flex;
  justify-content: center;
  align-items: baseline;
  z-index: 10001 !important;
  top: 73px !important;
}

.chat-bubble {
  background-color: #f0f0f0;
  /* Light green like WhatsApp */
  border-radius: 0.75rem;
  border-top-right-radius: 0px;
  padding: 0.75rem 1rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  position: relative;
  font-family: system-ui, sans-serif;
}

.sender-name {
  font-weight: bold;
  color: #3f51b5;
  /* WhatsApp blue */
  font-size: 0.7rem;
  margin-bottom: 0.25rem;
}

.message-text {
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.chat__footer {
  padding: 10px;
  background-color: #f9f5eb;
  height: 10vh;
  width: 100%;
}
.chat__footer  .form {
  height: 100%;
  align-items: center;
  justify-content: space-between;
}

.chat__footer  .message {
  width: 85%;
  height: 100%;
  border-radius: 10px;
  border: 1px solid #ddd;
  outline: none;
  padding: 15px;
}

 .chat__footer .sendBtn {
  width: 200px;
  padding: 20px;
  border: none;
  outline: none;
  color: #eae3d2;
  cursor: pointer;
}

.chat__footer  .sendBtn:hover {
  background-color: rgb(129, 201, 129);
}

.chat__footer  .message__recipient {
  background-color: rgb(191, 200, 226);
  /* background-color: #f5ccc2; */
  width: 300px;
  padding: 10px;
  border-radius: 10px;
  font-size: 15px;
  border: 1px solid black;
}

/* .message__sender{
background-color: rgb(194, 243, 194);
max-width: 300px;
padding: 10px;
border-radius: 10px;
margin-left: auto;
font-size: 15px;
} */

.chat__footer  .message__sender {
  text-align: left;
  background-color: rgb(194, 243, 194);
  padding: 5px 15px;
  border-radius: 10px;
  width: max-content;
  max-width: 82%;
  /* margin: auto;
  margin-right: 0; */
  margin-bottom: 10px;
  word-wrap: break-word;
  -webkit-border-radius: 10px 15px 0px 10px;
  -moz-border-radius: 10px 15px 0px 10px;
  -ms-border-radius: 10px 15px 0px 10px;
  -o-border-radius: 10px 15px 0px 10px;
}

.chat__footer  .message__chats {
  font-size: 13px;
  width: 102%;
}

.chat__footer  .sender__name {
  text-align: right;
}

.chat__footer  .message__status {
  position: fixed;
  bottom: 50px;
  font-size: 13px;
  font-style: italic;
}
/************* Ck Editor Width set to 100%*************** */
.ck-editor {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,mCAAmC;EACnC,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,4CAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,4CAAqC;AACvC;;AAEA;EACE,SAAS;EACT;;iBAEe;EACf,6CAA6C;EAC7C,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE;gBACc;EACd,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE;IACE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,sEAAsE;AACtE;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;AAChC;;AAEA,qDAAqD;AACrD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,kEAAkE;AACpE;;AAEA;EACE;IACE;+CAC2C;EAC7C;;EAEA;;IAEE;+CAC2C;EAC7C;;EAEA;;IAEE;;kCAE8B;EAChC;;EAEA;IACE;;iCAE6B;EAC/B;;EAEA;IACE;;gCAE4B;EAC9B;;EAEA;IACE;+CAC2C;EAC7C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAS;EACT,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAEhB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;;CAEC;EACC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;;;;;GAOG;;AAEH;EACE,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd;oBACkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA,2DAA2D;AAC3D;EACE,sBAAsB;AACxB","sourcesContent":[":root {\n  --blue: #016fe9;\n  --lightblue: #328aed;\n  --ultralightblue: #e6f1fd;\n  --white: #ffffff;\n  --gray: #353535;\n  --purple: #3f51b5;\n  --lightgray: #929294;\n  --lightpurple: #e8eaf5;\n  --transpurple: #e4e4f9;\n  --boxshadow: #9e9e9e;\n  --transgray: #e5e5e5;\n  --green: #158803;\n  --transblue: rgba(1, 111, 233, 0.1);\n  --whitegrey: rgba(255, 255, 255, 0.6);\n  --border: #ced4da;\n  --black: #000000;\n  --red: #f23e36;\n}\n\n@font-face {\n  font-family: \"Mulish\", sans-serif;\n  src: url(./Fonts/Mulish-Regular.ttf);\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Poppins\", sans-serif;\n  src: url(./Fonts/Poppins-Regular.ttf);\n}\n\nbody {\n  margin: 0;\n  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif; */\n  font-family: \"Poppins\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 14px !important;\n}\n\ncode {\n  /* font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace; */\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.css-1in441m {\n  display: none !important;\n}\n\n.font-12 {\n  font-size: 12px !important;\n}\n\n.font-14 {\n  font-size: 14px !important;\n}\n\n.font-16 {\n  font-size: 16px !important;\n}\n\n.font-11 {\n  font-size: 11px !important;\n}\n\n.font-11-req-msg {\n  font-size: 11px !important;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.removelabel label {\n  display: none;\n}\n\n.colorPurple {\n  color: var(--purple);\n}\n\n.bgPurple {\n  background: var(--purple);\n  color: #fff;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.bgwhite {\n  background: #fff;\n}\n\n.colorGreen {\n  color: var(--green);\n}\n\n/*******************Pagination**********************/\n.paginationdiv nav {\n  height: auto;\n  width: auto;\n  border: 0;\n}\n\n.MuiTablePagination-actions {\n  display: none;\n}\n\n.paginateno p {\n  margin-bottom: 0 !important;\n}\n\n.chatdate {\n  background: var(--lightpurple);\n  margin: auto;\n  padding: 5px;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n}\n\n/****************************************/\n/*******************Popup*****************/\n.model {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10001 !important;\n}\n\n.modeldiv {\n  background-color: var(--white);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  box-shadow: 0 0 6px var(--boxshadow);\n  padding: 60px;\n  min-width: 550px;\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n  max-width: calc(100vw - 100px);\n}\n\n@media screen and (max-width: 650px) {\n  .modeldiv {\n    min-width: unset;\n    width: calc(100vw - 32px);\n    padding: 24px 16px;\n  }\n}\n\n.modelprintdiv {\n  background-color: var(--white);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  box-shadow: 0 0 6px var(--boxshadow);\n  padding: 60px;\n  /* min-width: 95%; */\n  min-height: 90%;\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n  width: 100%;\n  max-width: 650px;\n}\n\n.css-10nakn3-MuiModal-root-MuiPopover-root-MuiMenu-root {\n  z-index: 10002 !important;\n}\n\n.modeldivChat {\n  min-width: 0px !important;\n  padding: 30px !important;\n  max-width: 80vw !important;\n  max-height: calc(100vh - 100px) !important;\n  overflow: auto;\n}\n\n.modeldivDelete {\n  background-color: var(--white);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  box-shadow: 0 0 6px var(--boxshadow);\n  padding: 60px;\n  min-width: 550px;\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n  max-width: calc(100vw - 100px);\n  z-index: 1;\n}\n\n.modelWaitingRecording {\n  background-color: var(--white);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  box-shadow: 0 0 6px var(--boxshadow);\n  padding: 60px;\n  min-width: 500px;\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n  max-width: 500px;\n  z-index: 1;\n}\n\n.modelInstructions {\n  background-color: var(--white);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  box-shadow: 0 0 6px var(--boxshadow);\n  padding: 30px;\n  min-width: 500px;\n  max-height: calc(100vh - 100px);\n  max-width: calc(100vw - 100px);\n  /* overflow: auto; */\n  z-index: 1;\n}\n\n.modelInstructionsContent {\n  max-height: calc(100vh - 260px);\n  overflow-y: auto;\n}\n\n.modelChat {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10001 !important;\n}\n\n/************************bookstock popup******************************/\n.bookstockmodeldiv {\n  background-color: var(--white);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  box-shadow: 0 0 6px var(--boxshadow);\n  padding: 60px;\n  min-width: 360px;\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n  max-width: calc(100vw - 100px);\n}\n\n/**********************Loader************************/\n.loaderBackdrop.MuiBackdrop-root {\n  z-index: 10002;\n}\n\n.loader {\n  color: #ffffff;\n  font-size: 45px;\n  text-indent: -9999em;\n  overflow: hidden;\n  width: 1em;\n  height: 1em;\n  border-radius: 50%;\n  position: relative;\n  transform: translateZ(0);\n  animation: mltShdSpin 1.7s infinite ease, round 1.7s infinite ease;\n}\n\n@keyframes mltShdSpin {\n  0% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,\n      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n\n  5%,\n  95% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,\n      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n\n  10%,\n  59% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em,\n      -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em,\n      -0.297em -0.775em 0 -0.477em;\n  }\n\n  20% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em,\n      -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em,\n      -0.749em -0.34em 0 -0.477em;\n  }\n\n  38% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em,\n      -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em,\n      -0.82em -0.09em 0 -0.477em;\n  }\n\n  100% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,\n      0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n}\n\n@keyframes round {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.MuiInputBase-root legend.css-yjsfm1 {\n  display: none !important;\n}\n\n.wrs_tickContainer {\n  display: none !important;\n}\n\n.boxshadow {\n  box-shadow: 1px 1px 5px 1px var(--transgray);\n}\n\n.tablecontent {\n  width: calc(100vw - 540px);\n}\n\n.pdfView {\n  width: 100vw;\n}\n\n.pdf-container div div {\n  display: none;\n}\n\n.pdf-container div {\n  background: var(--boxshadow1) !important;\n}\n\n.pdf-container canvas {\n  margin: auto;\n  max-width: 1000px !important;\n  width: 100% !important;\n  height: auto !important;\n}\n\n.controls {\n  text-align: center;\n  margin: 10px;\n}\n\n.MuiMenu-root {\n  z-index: 10002 !important;\n}\n\n/******************SCroll bar*****************************/\n::-webkit-scrollbar {\n  width: 0.8em;\n  height: 0.3em;\n  display: none;\n}\n\n.scrollBarContent ::-webkit-scrollbar {\n  display: inline-block;\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: var(--lightgray);\n  outline: 1px solid slategrey;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.scrollbar::-webkit-scrollbar {\n  display: inline-block;\n}\n\n@media print {\n  pdf-viewer {\n    display: none;\n  }\n\n  .pdfDiv {\n    display: none !important;\n  }\n\n  .pdf-container {\n    display: none;\n  }\n}\n\n.chat {\n  width: calc(100vw - 300px);\n  height: 78vh;\n  display: flex;\n  align-items: center;\n  margin: auto;\n}\n\n.teacherChat .chat {\n  width: 100%;\n  height: 100%;\n}\n\n.chat_hide {\n  width: 100%;\n  height: 100vh;\n  display: none;\n  align-items: center;\n}\n\n.chat__sidebar {\n  height: 100%;\n  background-color: #f9f5eb;\n  flex: 0.2;\n  padding: 20px;\n  border-right: 1px solid #fdfdfd;\n}\n\n.chat__main {\n  height: 100%;\n  /* flex: 0.8; */\n  width: 100%;\n}\n\n.message__container {\n  width: 100%;\n  height: calc(100vh - 236px);\n  background-color: #fff;\n  padding: 20px;\n  overflow-y: auto;\n  /* display: table-caption; */\n}\n\n.message__container>* {\n  margin-bottom: 15px;\n}\n\n.message__chats {\n  font-size: 14px;\n  width: 98%;\n}\n\n.message__recipient {\n  font-size: 14px;\n  word-wrap: break-word;\n  background-color: #c2f3c2;\n  border-radius: 10px;\n  -webkit-border-radius: 10px 15px 0 10px;\n  -moz-border-radius: 10px 15px 0 10px;\n  -ms-border-radius: 10px 15px 0 10px;\n  -o-border-radius: 10px 15px 0 10px;\n  margin: auto 0 5px auto;\n  max-width: 82%;\n  padding: 5px 15px;\n  text-align: left;\n  width: -webkit-max-content;\n  width: max-content;\n}\n\n.sender__name {\n  text-align: right;\n}\n\n.message__status {\n  position: fixed;\n  bottom: 50px;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.css-1d3z3hw-MuiOutlinedInput-notchedOutline {\n  top: 0 !important;\n}\n\n.message__sender {\n  text-align: left;\n  background-color: rgb(194, 243, 194);\n  padding: 5px 15px;\n  border-radius: 10px;\n  width: max-content;\n  max-width: 82%;\n  margin: auto;\n  margin-right: 0;\n  margin-bottom: 10px;\n  word-wrap: break-word;\n  -webkit-border-radius: 10px 15px 0px 10px;\n  -moz-border-radius: 10px 15px 0px 10px;\n  -ms-border-radius: 10px 15px 0px 10px;\n  -o-border-radius: 10px 15px 0px 10px;\n}\n\n.chatOwnerName {\n  font-size: 12px;\n}\n\n.alertBox {\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  z-index: 10001 !important;\n  top: 73px !important;\n}\n\n.chat-bubble {\n  background-color: #f0f0f0;\n  /* Light green like WhatsApp */\n  border-radius: 0.75rem;\n  border-top-right-radius: 0px;\n  padding: 0.75rem 1rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  position: relative;\n  font-family: system-ui, sans-serif;\n}\n\n.sender-name {\n  font-weight: bold;\n  color: #3f51b5;\n  /* WhatsApp blue */\n  font-size: 0.7rem;\n  margin-bottom: 0.25rem;\n}\n\n.message-text {\n  font-size: 0.95rem;\n  margin-bottom: 0.25rem;\n}\n\n.chat__footer {\n  padding: 10px;\n  background-color: #f9f5eb;\n  height: 10vh;\n  width: 100%;\n}\n.chat__footer  .form {\n  height: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.chat__footer  .message {\n  width: 85%;\n  height: 100%;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  outline: none;\n  padding: 15px;\n}\n\n .chat__footer .sendBtn {\n  width: 200px;\n  padding: 20px;\n  border: none;\n  outline: none;\n  color: #eae3d2;\n  cursor: pointer;\n}\n\n.chat__footer  .sendBtn:hover {\n  background-color: rgb(129, 201, 129);\n}\n\n.chat__footer  .message__recipient {\n  background-color: rgb(191, 200, 226);\n  /* background-color: #f5ccc2; */\n  width: 300px;\n  padding: 10px;\n  border-radius: 10px;\n  font-size: 15px;\n  border: 1px solid black;\n}\n\n/* .message__sender{\nbackground-color: rgb(194, 243, 194);\nmax-width: 300px;\npadding: 10px;\nborder-radius: 10px;\nmargin-left: auto;\nfont-size: 15px;\n} */\n\n.chat__footer  .message__sender {\n  text-align: left;\n  background-color: rgb(194, 243, 194);\n  padding: 5px 15px;\n  border-radius: 10px;\n  width: max-content;\n  max-width: 82%;\n  /* margin: auto;\n  margin-right: 0; */\n  margin-bottom: 10px;\n  word-wrap: break-word;\n  -webkit-border-radius: 10px 15px 0px 10px;\n  -moz-border-radius: 10px 15px 0px 10px;\n  -ms-border-radius: 10px 15px 0px 10px;\n  -o-border-radius: 10px 15px 0px 10px;\n}\n\n.chat__footer  .message__chats {\n  font-size: 13px;\n  width: 102%;\n}\n\n.chat__footer  .sender__name {\n  text-align: right;\n}\n\n.chat__footer  .message__status {\n  position: fixed;\n  bottom: 50px;\n  font-size: 13px;\n  font-style: italic;\n}\n/************* Ck Editor Width set to 100%*************** */\n.ck-editor {\n  width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
